export const internalSalesCampaign = {
	title: "Campanhas internas",
	subtitle:
		"Crie campanhas internas, acompanhe o progresso e gerencie o pagamento de bonificações.",
	tabs: {
		campaign: "Campanhas",
		bonusManagement: "Gestão de bonificação",
	},
	messages: {
		errorMsg: "Erro ao encerrar a campanha",
		errorDescriptionError:
			"Por favor, tente novamente mais tarde ou entre em contato com o suporte.",
		successMsg: "Sucesso!",
		successDescription: "Uma campanha foi criada!",
		warnMsg: "Encerrar campanha",
		warnDescription:
			"Esta campanha será finalizada antes do período estabelecido. Caso a campanha já tenha iniciado, isso poderá impactar diretamente na meta dos colaboradores e nas vendas. Deseja prosseguir?",
		closeCampaignMsg: "Sim, encerrar campanha",
		close: "Fechar",
		editcampaign: "Editar campanha",
		duplicateCampaign: "Duplicar campanha",
		closeCampaignBtn: "Encerrar campanha",
	},
	campaignDetails: {
		back: "Voltar",
		summary: "Resumo",
		position: "Posição",
		points: "Pontos",
		downloadExcel: "Exportar para Excel",
		resultsPerPage: "Resultados por página",
		operator: "OPERADOR (USER)",
		ranking: "Ranking de operadores",
	},
	modal: {
		confirmationTitle: "Sua campanha não foi criada",
		continuebtn: "Não, continuar configuração",
		exitBtn: "Sim, sair sem salvar",
		content:
			"Ao sair as configurações da campanha serão perdidas e essa ação não poderá ser desfeita. Deseja continuar?",
	},
	steps: {
		generalSettings: "Configurações gerais",
		generalSettingsDetails: "Configure os detalhes da sua campanha.",
		withBonusExtra: "O {{position}}º lugar no ranking geral ganhará o bônus extra de",
		withBonus: "O {{position}}º lugar no ranking geral ganhará o bônus de",
		salesTarget: "Meta de vendas",
		selectWinners: "Selecione o(s) ganhador(es) e configure o valor:",
		prizeByRanking: "Premiar por ranking",
		addPositionToRanking: "Adicionar posição ao ranking",
		onlyFirstPlace: "Apenas o 1º lugar no ranking geral",
		onlyFirstAndSecondPlace: "Apenas o 1º e 2º lugar no ranking geral",
		top3: "Apenas o top 3 no ranking geral",
		allOperators: "Todos que alcançarem a meta",
		bonus: "Bonificação",
		winnerQuantity: "Quantidade de ganhador(es)",
		winnerQuantityPlaceholder: "Selecione a quantidade de ganhadores",
		summary: "Resumo",
		cancel: "Cancelar",
		allSettings: "Todas as configurações",
		back: "Voltar",
		next: "Próximo",
		finish: "Finalizar",
		campaignLocale: "Local da campanha",
		campaignLocalePlaceholder: "Selecione um ou mais locais para esta campanha",
		campaignName: "Nome da campanha",
		charCount: "Quantidade máxima de caracteres: 20",
		campaignNamePlaceholder: "Digite o nome da campanha",
		sponsor: "Patrocinador (opcional)",
		sponsorPlaceholder: "Digite o nome do patrocinador",
		salesTargetDescription: "Escolha o tipo de meta que sua campanha irá focar.",
		campaign: "Campanha",
		campaignSubtitle: "Configure os detalhes da sua campanha.",
		startDate: "Data inicial da campanha",
		endDate: "Data final da campanha",
		dateInfo:
			"Atenção: A campannha só poderá ser editada até 30 minutos antes do horário programado para iniciar.",
		types: {
			soldProducts: "Por produto",
			soldProductsPlaceholder: "Escolha um produto",
			soldProductsDescription:
				"Defina um produto estratégico como meta para a sua campanha.",
			productsQuantity: "Meta de vendas (qtd.)",
			selectProducts: "Produto",
			salesTotal: "Por valor total em vendas",
			salesTotalDescription:
				"Defina um valor total em vendas como meta para a sua campanha.",
			salesTotalGoal: "Valor da meta",
			metaType: "Tipo de meta",
			metaTypeTooltip:
				"A meta é o objetivo da campanha e serve para medir o desempenho dos colaboradores. Pode ser definida por: quantidade de produtos vendidos, número de atendimentos ou valor total em vendas.",
			selectTypeGoal: "Selecione o tipo de meta",
			attendance: "Por atendimento",
			attendanceGoal: "Quantidade",
			attendanceDescription:
				"Defina uma quantidade de atendimento (de pessoas ou mesas) como meta para sua campanha.",
		},
		bonusContent: {
			title: "Bonificação",
			subtitle:
				"Selecione e configure o tipo de bonificação a ser concedida ao colaborador.",
			moneyTitle: "Bônus em dinheiro",
			moneySubtitle: "Bônus com pagamento em dinheiro (espécie) ou via PIX.",
			bonusTitle: "Cashless Zig",
			bonusSubtitle:
				"Bônus disponibilizado no CPF ou no cartão de consumo Cashless Zig do(s) colaborador(es).",
			featuredContribuitorTitle: "Colaborador em destaque",
			featuredContribuitorSubtitle:
				"Esta bonificação é um reconhecimento por mérito. A aplicação será definida pelo gestor.",
			slackTitle: "Folga extra",
			slackSubtitle:
				"Este bônus concede um dia de folga extra, além do regular. A aplicação será definida pelo gestor.",
			winnersQuantity: "Qtd. de ganhador (es)",
			firstPlaceBonus: "Bônus 1º lugar",
			scondPlaceBonus: "Bônus 2º lugar",
			thirdPlaceBonus: "Bônus 3º lugar",
		},
		resume: {
			title: "Resumo",
			subtitle: "Confira o resumo da configuração da campanha.",
			warning:
				"Atenção: Após a criação da campanha, a mesma só poderá ser editada até 30 minutos antes do horário programado para iniciar.",
			geralSettings: "Configurações gerais",
			campaignLocale: "Local da campanha",
			campaignName: "Nome da campanha",
			sponsor: "Patrocinador",
			schedule: "Programação",
			initialDate: "Data inicial da campanha",
			endDate: "Data final da campanha",
			goal: "Meta de vendas",
			type: "Tipo",
			goalSell: "Meta de vendas",
			product: "Produto",
			bonus: "Bonificação",
			bonusType: "Tipo de bonificação",
			winnerQuantity: "Quantidade de ganhador(es)",
			allOperators: "Todos os operadores que alcançarem a meta ganhará o bônus de",
		},
	},
	bonusManagement: {
		filters: {
			campaignName: "Filtrar por nome da campanha",
			campaignStatus: "Filtrar por status",
			operatorName: "Filtrar por nome de operador",
			pending: "Pendente",
			done: "Efetuado",
		},
		paymentType: {
			bonus: "Bônus",
			dayOff: "Folga extra",
			employeeOfTheMonth: "Colaborador do mês",
			money: "Dinheiro",
			pix: "PIX",
		},
		table: {
			status: "STATUS",
			campaignName: "CAMPANHA",
			operator: "OPERADOR",
			bonusType: "TIPO DE BÔNUS",
			value: "VALOR",
			retrievedAt: "EFETUADO EM",
			retrievedBy: "RESPONSÁVEL",
			confirmBonus: "Confirmar bônus",
		},
	},
	newCampaign: "Criar campanha",
	campaign: {
		cards: {
			active: "Campanhas ativas",
			campaignsProgramed: "Campanhas programadas",
			campaignsConcluded: "Campanhas concluídas",
			totalProductsSold: "Total em venda",
			onSale: "Campanhas em curso",
		},
		filters: {
			campaignName: "Filtrar por nome da campanha",
			campaignStatus: "Filtrar por status",
			operatorName: "Filtrar por nome de operador",
		},
		table: {
			noContent: "Nenhuma campanha encontrada",
			checkFilters: "Crie uma campanha ou verifique os filtros.",
			status: "STATUS",
			campaignName: "CAMPANHA",
			start: "INÍCIO",
			end: "FIM",
			metaType: "TIPO DE META",
			productsSell: "PRODUTOS VENDIDOS",
			services: "ATENDIMENTOS",
			totalValue: "VALOR TOTAL",
			edit: "Editar campanha",
			duplicate: "Duplicar campanha",
			finish: "Encerrar campanha",
		},
		tags: {
			active: "Ativa",
			finished: "Finalizada",
			scheduled: "Programada",
			onSale: "Em curso",
		},
	},
};
